import dynamic from 'next/dynamic'
import { useEffect } from 'react'
import { Intercom as IntercomLoader } from 'react-live-chat-loader';

const APP_ID = 'orpdg3jb'

const IntercomComponent = dynamic(
  () => Promise.resolve(IntercomLoader),
  {ssr:false}
)

const Intercom = ()=> {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.intercomSettings = {
        api_base: 'https://api-iam.intercom.io',
        app_id: APP_ID,
        hide_default_launcher: false,
        action_color: '#6e868a',
        utm_campaign: 'Yadav Website',
        utm_medium: 'ecommerce',
        utm_source: 'yadavjewelry.com',
      };
    }
  }, []);

  return (
    <IntercomComponent color="#6e868a" />
  );
}

export default Intercom
